import { create } from "zustand/react";
import { useShallow } from "zustand/react/shallow";

interface UiBrandingStore {
  state: string;
  searchKeyword: string;
  actions: {
    setSearchKeyword: (keyword: string) => void;
    unMount: () => void;
    setState: (state: string) => void;
  };
}

const defaultUiBrandingStoreData = {
  state: "active",
  searchKeyword: "",
};

const useUiBrandingStore = create<UiBrandingStore>((set) => ({
  ...defaultUiBrandingStoreData,
  actions: {
    setSearchKeyword: (keyword) =>
      set(() => ({
        searchKeyword: keyword,
      })),
    unMount: () =>
      set(() => ({
        ...defaultUiBrandingStoreData,
      })),
    setState: (state) =>
      set(() => ({
        state,
      })),
  },
}));

export const useUiBrandingData = () =>
  useUiBrandingStore(
    useShallow((state) => ({
      state: state.state,
      searchKeyword: state.searchKeyword,
    })),
  );

export const useUiBrandingActions = () =>
  useUiBrandingStore((state) => state.actions);
